import React, { Component } from 'react';
import PropTypes from "prop-types";
import {connect} from 'react-redux';

class sectionLegal extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  scrollToSelection() {
    // do the scroll only if there's support for it
    if (window.document.body.scrollIntoView && window.scrollBy) {
      window.document
        .getElementById(`${this.props.selection}-anchor`)
        .scrollIntoView()
      window.scrollBy(0, -20)

      // go with the hash solution if no support is provided
    } else {
      window.location.hash = `#${this.props.selection}-anchor`
    }
  }

  componentDidMount() {
    this.scrollToSelection()
  }
  componentDidUpdate() {
    this.scrollToSelection()
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].legal

    const content = Object.entries(langPlace.notices).map(([key, value]) =>
      (
        <div key={key} id={`${key}-anchor`} className={`legal-text-${key}`}>
          <h1 className="h3 heavy">{value.title}</h1>
          <p className="light" dangerouslySetInnerHTML={{ __html: value.content }}></p>
        </div>
      )
    )

    return (
      <div className="container-fluid">

        <section className="section-text row">
          <div className="container">
            <div className="row">

              <div className="col-md-12">
                {content}
              </div>

            </div>
          </div>
        </section>

      </div>
    )
  }
}

export default connect(
  (state) => ({settings: state.settings})
)(sectionLegal)



// WEBPACK FOOTER //
// ./src/shared/routes/routeLegal/sectionLegal.js